import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Tab, Nav } from "react-bootstrap";
import {
  AiOutlineFileSearch,
  CgMenuLeftAlt,
  CgMenuRightAlt,
} from "react-icons/all";
import { AXIOS, api_key } from "../../../config";
import icon1 from '../../../assets/images/spot/spot1.png'
import icon2 from '../../../assets/images/spot/spot2.png'
import icon3 from '../../../assets/images/spot/spot3.png'
import icon4 from '../../../assets/images/spot/spot_Icon.png'

import "../spot_styles/spotlower.css";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { array } from "yup";
import { sellOrder as sellOrderInfo } from "../../../store/spot";
import { buyOrder as buyOrderInfo } from "../../../store/spot";
import { addingSameTargetPrice, formatNumberWithDecimals } from "../../../helperData/helper";

export default function TradeOrderBook() {
  let userid = sessionStorage.getItem("userid");

  const dispatch = useDispatch();
  const [sellOrder, setSellOrder] = useState<any>([]);
  const [buyOrder, setBuyOrder] = useState<any>([]);
  const { orderType, isCreatedOrder } = useSelector((state: any) => state.spot);
  const { pairName, pairTwoSymbol, pairOneSymbol } = useSelector(
    (state: any) => state.pair
  );

  const tableData = [
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
    {
      price: 0.000234,
      amount: 4,
      total: 0.00094,
    },
  ];

  const { isLogin } = useSelector((state: any) => state.auth);


  const getBuyAndSellOrders = async () => {
   await AXIOS.post(`getOrders?type=${orderType}&&method=sell&&pair=${pairName}`, {
      api_key: api_key,
      // user_id: userid,
    })
      .then((response: any) => {



        let result =  addingSameTargetPrice(response.data.data)

        setSellOrder(
          result.sort((a, b) => a.target_price - b.target_price)
        );
      })
      .catch((error) => console.log("error", error.message));
    await AXIOS.post(`getOrders?type=${orderType}&&method=buy&&pair=${pairName}`, {
      api_key: api_key,
      // user_id: userid,
    })
      .then((response: any) => {
        console.log('response buy order', response.data.data)

        let result =  addingSameTargetPrice(response.data.data)
        console.log('result buy order', result)
        setBuyOrder(
          result.sort((a, b) => b.target_price - a.target_price)
        );
      })
      .catch((error) => console.log("error", error.message));
  };
  useEffect(() => {
    if (pairName) {
      getBuyAndSellOrders();
    }
  }, [orderType, isCreatedOrder, , pairName, isLogin]);

  const calculateSell = async (index: number, targetPrice: string) => {
    let value = sellOrder.slice(0, index + 1);
    const sum = value.reduce((accumulator, currentObject: any) => {
      return accumulator + currentObject["amount"];
    }, 0);
    dispatch(
      sellOrderInfo({
        targetPrice: targetPrice,
        sumAmount: String(sum),
      })
    );
  };
  const calculateBuy = async (index: number, targetPrice: string) => {
    let value = buyOrder.slice(0, index + 1);

    const sum = value.reduce((accumulator, currentObject: any) => {
      return accumulator + currentObject["amount"];
    }, 0);
    dispatch(
      buyOrderInfo({
        targetPrice: targetPrice,
        sumAmount: String(sum),
      })
    );
  };

  return (
    <Container fluid className="lower_spot m-0 p-0">
      <Row className="m-0 p-0 spot_low">
        <Col className="lower_spot_left_left_orderbook">
          <div className="lower_spot_left_head mt-1">
            <h6>Order Book </h6>
            {/* <img src={icon1} alt="" /> */}
          </div>
          <div className="orderbook_tabs flex">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Nav variant="pills" className="flex-row gap-0">
                <Nav.Item>
                  <Nav.Link eventKey="first">
                    {/* <CgMenuRightAlt /> */}
                    <img src={icon1} alt="" width={"22px"} height={"18px"} />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">
                    {/* <CgMenuLeftAlt /> */}
                    <img src={icon3} alt="" width={"22px"} height={"18px"} />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">
                    {/* <CgMenuRightAlt /> */}
                    <img src={icon2} alt="" width={"22px"} height={"18px"} />
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <div className="lower_spot_table_left_up lower_spot_left_left_orderbook1">
                    <Table borderless>
                      <thead>
                        <tr>
                          <td>Price ({pairTwoSymbol})</td>
                          <td className="text-end">Amount ({pairOneSymbol})</td>
                          <td className="text-end">Total</td>
                        </tr>
                      </thead>

                      <tbody className="lower_spot_table_left_up">

                        {/* Upper version code is dummy just to show data on static ui, dynamic code is commented below */}

                        {sellOrder.length > 0 ? (
                          sellOrder.map((item: any, index: number) => {
                            return (
                              <tr
                                className="clickable-row"
                                onClick={() => {
                                  calculateSell(index, item.target_price);
                                }}

                              >
                                <td className="lower_order_fst_td_orderbook">
                                  {item.target_price}
                                </td>
                                <td className="lower_order_other_td_orderbook">
                                  {item.amount}
                                </td>
                                <td className="lower_order_other_td_orderbook">
                                  {formatNumberWithDecimals(
                                    item.target_price * item.amount,
                                    5
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <>

                            <div className="text-center mt-5" style={{ color: 'var(--text-clr)' }}>
                              <div className='display-6'>
                                <i> <AiOutlineFileSearch /> </i>
                              </div>
                              <div>
                                <span>No records found</span>
                              </div>
                            </div>
                          </>
                        )}
                      </tbody>
                    </Table>

                    <Table borderless>
                      <thead>
                        <h6 className="orderbook_hglight">
                          29170.7<small className="orderbook_hglight_small">$29169.7</small>
                        </h6>
                      </thead>

                      <tbody>

                        {/* Upper version code is dummy just to show data on static ui, dynamic code is commented below */}

                        {buyOrder.length > 0 ? (
                          buyOrder.map((item: any, index: number) => {
                            return (
                              <tr
                                className="clickable-row"
                                onClick={() => {
                                  calculateBuy(index, item.target_price);
                                }}
                              >
                                <td className="lower_order_lowfst_td_orderbook">
                                  {item.target_price}
                                </td>
                                <td className="lower_order_other_td_orderbook">
                                  {item.amount}
                                </td>
                                <td className="lower_order_other_td_orderbook">
                                  {formatNumberWithDecimals(
                                    item.target_price * item.amount,
                                    5
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <>

                            <div className="text-center mt-5" style={{ color: 'var(--text-clr)' }}>
                              <div className='display-6'>
                                <i> <AiOutlineFileSearch /> </i>
                              </div>
                              <div>
                                <span>No records found</span>
                              </div>
                            </div>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="second" className="orderbook_tab2">
                  <div className="lower_spot_table_left_up lower_spot_left_left_orderbook2">
                    <Table borderless>
                      <thead>
                        <h6 className="orderbook_hglight">
                          29170.7
                          <small className="orderbook_hglight_small">
                            $29169.7
                          </small>
                        </h6>
                      </thead>

                      <tbody>

                        {/* Upper version code is dummy just to show data on static ui, dynamic code is commented below */}

                        {buyOrder.length > 0 ? (
                          buyOrder.map((item: any, index: number) => {
                            return (
                              <tr
                                className="clickable-row"
                                onClick={() => {
                                  calculateBuy(index, item.target_price);
                                }}
                              >
                                <td className="lower_order_lowfst_td_orderbook">
                                  {item.target_price}
                                </td>
                                <td className="lower_order_other_td_orderbook">
                                  {item.amount}
                                </td>
                                <td className="lower_order_other_td_orderbook">
                                  {formatNumberWithDecimals(
                                    item.target_price * item.amount,
                                    5
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <>

                            <div className="text-center mt-5">
                              <div className='display-6'>
                                <i> <AiOutlineFileSearch /> </i>
                              </div>
                              <div>
                                <span>No records found</span>
                              </div>
                            </div>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="third" className="orderbook_tab3">
                  <div className="lower_spot_table_left_up lower_spot_left_left_orderbook3">
                    <Table borderless>
                      <thead>
                        <tr>
                          <td>Price ({pairTwoSymbol})</td>
                          <td className="text-end">Amount ({pairOneSymbol})</td>
                          <td className="text-end">Total</td>
                        </tr>
                      </thead>

                      <tbody className="lower_spot_table_left_up">

                        {/* Upper version code is dummy just to show data on static ui, dynamic code is commented below */}

                        {sellOrder.length > 0 ? (
                          sellOrder.map((item: any, index: number) => {
                            return (
                              <tr
                                className="clickable-row"
                                onClick={() => {
                                  calculateSell(index, item.target_price);
                                }}
                              >
                                <td className="lower_order_fst_td_orderbook">
                                  {item.target_price}
                                </td>
                                <td className="lower_order_other_td_orderbook">
                                  {item.amount}
                                </td>
                                <td className="lower_order_other_td_orderbook">
                                  {formatNumberWithDecimals(
                                    item.target_price * item.amount,
                                    5
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <>

                            <div className="text-center mt-5">
                              <div className='display-6'>
                                <i> <AiOutlineFileSearch /> </i>
                              </div>
                              <div>
                                <span>No records found</span>
                              </div>
                            </div>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  <h6 className="orderbook_hglight d-flex align-items-center gap-1">
                    29170.7
                    <small className="orderbook_hglight_small">$29169.7</small>
                  </h6>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
